import { useState } from 'react';
import {
  CREDITOS,
  ENVIO_DIGITAL,
  FACEBOOK_URL,
  FAQ_ITEMS,
  INSTAGRAM_URL,
  MAIL_INFO,
  TIENDA_URL,
  useCampaignSeo,
  WEB_OFICIAL,
  YOUTUBE_URL,
} from './seo';

const MAIL_LUCAS = 'lucas@oasis-multimedia.com';
const WHATSAPP = '34627655213';
const WHATSAPP_HREF = `https://wa.me/${WHATSAPP}`;
const STRIPE_PREVENTA_5 = 'https://buy.stripe.com/5kQdR97ZC4W30Rg1M6efC0e';
const STRIPE_CD_10 = 'https://buy.stripe.com/fZu5kD2Fi9cj9nM4YiefC0f';
const STRIPE_VINILO_17 = 'https://buy.stripe.com/9B66oH3JmewD43s9eyefC0g';
const STRIPE_NUFAN = 'https://buy.stripe.com/3cI00jeo0covfMa0I2efC0i';
const STRIPE_LAGWAGON = 'https://buy.stripe.com/9B6bJ1bbO74beI60I2efC0h';
const SPOTIFY_OPEN = 'https://open.spotify.com/artist/64JvWCPgh3pJ3Q0i1XwGLY?si=V3c5LpxuS8uCnxx7X3OPFQ';
const SPOTIFY_EMBED =
  'https://open.spotify.com/embed/artist/64JvWCPgh3pJ3Q0i1XwGLY?utm_source=generator';
const DOSSIER_PDF = '/dossier-patrocinio.pdf';
const BANDA_FOTO = '/img/IMG_0136.JPEG';

function checkoutHref(stripeUrl, packLabel) {
  if (stripeUrl) return stripeUrl;
  const text = encodeURIComponent(`Hola, quiero comprar ${packLabel}.`);
  return `https://wa.me/${WHATSAPP}?text=${text}`;
}

function PackCard({
  featured,
  buyNow,
  image,
  imageAlt,
  kicker,
  title,
  price,
  blurb,
  items,
  href,
  cta,
}) {
  return (
    <div
      className={
        featured
          ? 'relative p-6 pt-10 md:p-8 md:pt-12 flex flex-col h-full transition-all duration-300 highlight-cyan bg-[#111] z-20 shadow-[0_0_40px_rgba(0,242,255,0.12)]'
          : 'relative p-6 pt-10 md:p-8 md:pt-12 flex flex-col h-full transition-all duration-300 bg-[#111] border-2 border-gray-800 hover:border-white'
      }
    >
      {buyNow && (
        <div className="absolute -top-3 left-6 bg-[#e60000] text-white font-heading text-xs uppercase tracking-widest px-3 py-1">
          Comprar ya
        </div>
      )}
      {featured && (
        <div className="absolute -top-3 left-6 bg-[#00f2ff] text-black font-heading text-xs uppercase tracking-widest px-3 py-1">
          Preventa 5 €
        </div>
      )}
      {image && (
        <div className="mb-6 -mx-2 bg-[#0a0a0a] border border-gray-800 overflow-hidden">
          <img
            src={image}
            alt={imageAlt}
            className="w-full h-auto object-cover"
            loading={featured ? 'eager' : 'lazy'}
            decoding="async"
          />
        </div>
      )}
      <div className="flex-grow">
        <p className="text-xs uppercase tracking-[0.2em] text-gray-500 mb-2">{kicker}</p>
        <h3 className="font-heading text-3xl md:text-4xl uppercase leading-none mb-3 tracking-tighter">{title}</h3>
        <div className="flex items-baseline gap-2 mb-5">
          <span className={`font-heading text-5xl ${featured ? 'text-[#00f2ff]' : 'text-[#e60000]'}`}>{price}</span>
        </div>
        <p className="text-gray-400 mb-6 font-light leading-snug border-t border-gray-800 pt-4">{blurb}</p>
        <ul className="space-y-3 text-left mb-8">
          {items.map((item) => (
            <li key={item} className="flex items-start text-sm uppercase tracking-tight text-gray-300">
              <span className="text-[#e60000] font-marker mr-2 text-xl">X</span>
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </div>
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={
          featured
            ? 'mt-auto w-full block text-center font-heading text-2xl py-4 uppercase tracking-wider transition-all bg-[#00f2ff] text-black hover:bg-white shadow-[5px_5px_0px_rgba(255,255,255,1)]'
            : 'mt-auto w-full block text-center font-heading text-2xl py-4 uppercase tracking-wider transition-all bg-[#e60000] text-white hover:bg-white hover:text-black'
        }
      >
        {cta}
      </a>
    </div>
  );
}

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  useCampaignSeo();

  const closeMenu = () => setMenuOpen(false);

  return (
    <div className="bg-black text-white min-h-screen selection:bg-punk-red selection:text-white">
      <header className="fixed top-0 left-0 right-0 z-50 border-b border-white/5 bg-black/80 backdrop-blur-md">
        <div className="container mx-auto px-4 md:px-8">
          <div className="flex justify-between items-center h-20">
            <a href="#inicio" className="flex items-center gap-3" onClick={closeMenu}>
              <img src="/img/delest-logo.png" alt="DELEST, punk rock de Castellón" className="h-10 w-auto" />
            </a>
            <nav className="hidden md:flex items-center space-x-2" aria-label="Principal">
              <a
                href="#proyecto"
                className="block py-2 px-4 uppercase tracking-wider text-gray-300 transition-colors hover:text-punk-red"
              >
                El proyecto
              </a>
              <a
                href="#comprar"
                className="block py-2 px-4 uppercase tracking-wider text-gray-300 transition-colors hover:text-punk-red"
              >
                Comprar
              </a>
              <a
                href="#empresas"
                className="block py-2 px-4 uppercase tracking-wider text-gray-300 transition-colors hover:text-punk-red"
              >
                Empresas
              </a>
              <a
                href="#escuchar"
                className="block py-2 px-4 uppercase tracking-wider text-gray-300 transition-colors hover:text-punk-red"
              >
                Escuchar
              </a>
              <a
                href="#contacto"
                className="block py-2 px-4 uppercase tracking-wider text-gray-300 transition-colors hover:text-punk-red"
              >
                Contacto
              </a>
              <a
                href="#comprar"
                className="ml-4 bg-punk-red text-white font-heading py-2 px-5 uppercase text-sm tracking-wider transition-transform duration-300 hover:scale-105"
              >
                Comprar
              </a>
            </nav>
            <div className="md:hidden">
              <button
                type="button"
                className="text-white focus:outline-none p-2"
                aria-label={menuOpen ? 'Cerrar menú' : 'Abrir menú'}
                aria-expanded={menuOpen}
                onClick={() => setMenuOpen((open) => !open)}
              >
                {menuOpen ? (
                  <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                ) : (
                  <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M4 6h16M4 12h16m-7 6h7"
                    />
                  </svg>
                )}
              </button>
            </div>
          </div>
        </div>
        {menuOpen && (
          <nav className="md:hidden border-t border-white/10 bg-black/95" aria-label="Móvil">
            <div className="container mx-auto px-4 py-4 flex flex-col gap-1">
              {[
                ['#proyecto', 'El proyecto'],
                ['#comprar', 'Comprar'],
                ['#empresas', 'Empresas'],
                ['#escuchar', 'Escuchar'],
                ['#contacto', 'Contacto'],
              ].map(([href, label]) => (
                <a
                  key={href}
                  href={href}
                  onClick={closeMenu}
                  className="block py-3 px-4 uppercase tracking-wider text-gray-200 hover:text-punk-red"
                >
                  {label}
                </a>
              ))}
              <a
                href="#comprar"
                onClick={closeMenu}
                className="mt-2 bg-punk-red text-white font-heading py-3 px-5 uppercase text-sm tracking-wider text-center"
              >
                Comprar
              </a>
            </div>
          </nav>
        )}
      </header>

      <main>
        <header
          id="inicio"
          className="relative min-h-[85vh] flex flex-col items-center justify-center text-white text-center p-6 pt-28 bg-black overflow-hidden"
        >
          <div className="absolute inset-0 opacity-20 pointer-events-none">
            <div className="absolute top-10 -left-10 text-[20rem] font-heading leading-none select-none opacity-10 rotate-12">
              PUNK
            </div>
            <div className="absolute bottom-10 -right-10 text-[15rem] font-heading leading-none select-none opacity-10 -rotate-12">
              DIY
            </div>
          </div>
          <div className="relative z-10 max-w-5xl">
            <div className="inline-block bg-[#e60000] px-6 py-2 rotate-[-2deg] mb-6">
              <span className="font-marker text-2xl uppercase tracking-tighter">Preventa · single 2026</span>
            </div>
            <h1 className="font-heading text-5xl sm:text-7xl md:text-8xl lg:text-9xl uppercase leading-[0.9] mb-4 drop-shadow-[5px_5px_0px_rgba(230,0,0,1)]">
              <span className="sr-only">DELEST — </span>
              Ni con el viento
              <br />a favor
            </h1>
            <p className="mt-6 text-2xl md:text-3xl font-sans text-gray-200 max-w-3xl mx-auto leading-tight tracking-tight">
              Tras 3 años de silencio, DELEST vuelve con un nuevo single antesala del próximo disco. Grabado en
              Rockaway Studios, con Raúl Artana a la producción y los arreglos, vuelve el sonido más punkrock
              californiano.
            </p>
            <div className="mt-12 flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-5 w-full max-w-xl mx-auto">
              <a
                href="#comprar"
                className="group relative inline-block w-full sm:w-auto px-10 py-5 bg-white text-black font-heading text-2xl sm:text-3xl uppercase whitespace-nowrap transition-transform hover:scale-105 active:scale-95 text-center"
              >
                <span className="relative z-10">Colabora 5 €</span>
                <div className="absolute inset-0 bg-punk-red translate-x-2 translate-y-2 -z-10 transition-transform group-hover:translate-x-1 group-hover:translate-y-1" />
              </a>
              <a
                href="#empresas"
                className="inline-block w-full sm:w-auto px-8 py-5 border-2 border-white/80 text-white font-heading text-xl uppercase tracking-wider hover:bg-white hover:text-black transition-colors text-center"
              >
                Soy una empresa
              </a>
            </div>
            <p className="mt-6 text-sm md:text-base text-gray-400 max-w-2xl mx-auto">
              Preventa 5 €: el single y la discografía digital. {ENVIO_DIGITAL}
            </p>
          </div>
        </header>

        <div className="container mx-auto px-4 md:px-8 pt-0">
          <section id="proyecto" className="py-8 md:py-12 scroll-mt-24">
            <div className="max-w-5xl mx-auto flex flex-col md:flex-row gap-8 md:gap-16 items-start">
              <div className="flex-1 text-left rotate-small">
                <h2 className="font-heading text-6xl md:text-8xl uppercase tracking-tighter mb-8 text-white">
                  <span className="text-[#e60000]">01.</span> EL PLAN
                </h2>
                <div className="space-y-6 text-xl md:text-2xl font-light leading-snug">
                  <p className="bg-white text-black p-4 inline-block font-bold">El single</p>
                  <p className="text-gray-300">
                    Tres años parados y volvemos con este tema, el primero del disco nuevo. Lo grabamos en Rockaway
                    Studios. Producción y arreglos de Raúl Artana.
                  </p>
                  <p className="text-gray-300">
                    La preventa a 5 € incluye el single y la discografía digital completa. Con eso avanzamos máster,
                    videoclip y lanzamiento. Independientes, sin discográfica.
                  </p>
                  <p className="text-gray-400 italic">
                    {ENVIO_DIGITAL} El CD y el vinilo de Persistencia salen hacia tu casa al hacer el pedido.
                  </p>
                </div>
              </div>

              <div className="w-full md:w-2/5 bg-[#111] p-10 border-2 border-dashed border-gray-700 rotate-small-inverse relative">
                <p className="text-white text-lg md:text-xl font-medium mb-6 leading-relaxed">
                  5 € de preventa. El físico, si lo quieres, se compra ya.
                </p>
                <h3 className="font-heading text-4xl uppercase mb-8 border-b-4 border-[#e60000] inline-block">
                  A qué va
                </h3>
                <ul className="plan-list space-y-8 font-marker text-2xl md:text-3xl uppercase tracking-tighter text-gray-200">
                  <li>
                    Máster final
                    <p className="font-sans text-xs text-gray-500 mt-1 tracking-widest uppercase">
                      El empujón que falta para cerrar el disco
                    </p>
                  </li>
                  <li>
                    Videoclip profesional
                    <p className="font-sans text-xs text-gray-500 mt-1 tracking-widest uppercase">
                      Parte del lanzamiento del single
                    </p>
                  </li>
                  <li>
                    Campaña de prensa
                    <p className="font-sans text-xs text-gray-500 mt-1 tracking-widest uppercase">
                      Para que el tema llegue más lejos
                    </p>
                  </li>
                </ul>
              </div>
            </div>

            <div className="max-w-3xl mx-auto mt-16 md:mt-20">
              <figure className="relative group">
                <div className="absolute -inset-3 md:-inset-4 bg-[#e60000]/15 border-2 border-[#e60000]/40 rotate-1 pointer-events-none group-hover:rotate-0 transition-transform duration-500" />
                <img
                  src={BANDA_FOTO}
                  alt="DELEST, banda de punk rock de Castellón"
                  className="relative w-full h-auto border-4 border-white shadow-[8px_8px_0px_rgba(230,0,0,1)] -rotate-1 group-hover:rotate-0 transition-transform duration-500"
                  loading="lazy"
                  decoding="async"
                />
              </figure>
              <p className="mt-5 text-center text-xs md:text-sm uppercase tracking-[0.22em] text-gray-500">
                Delest · Castellón · 11 años de trayectoria
              </p>
            </div>
          </section>

          <section id="comprar" className="py-20 relative scroll-mt-24">
            <div className="absolute top-0 left-0 w-full h-20 bg-gradient-to-b from-black to-transparent pointer-events-none" />
            <div className="text-center mb-12">
              <p className="text-[#e60000] font-heading text-xl md:text-2xl uppercase tracking-[0.2em] mb-3">
                Preventa y tienda
              </p>
              <h2 className="font-heading text-6xl md:text-8xl lg:text-9xl uppercase tracking-tighter mb-4">
                Comprar <span className="text-[#e60000]">ahora</span>
              </h2>
              <p className="text-gray-300 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed">
                La preventa del single son 5 €, con toda la discografía digital del grupo de regalo. CD y vinilo de
                Persistencia salen hacia tu casa al pedirlos. Envío del nuevo single en exclusiva antes de la
                publicación en plataformas.
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 max-w-6xl mx-auto px-2 md:px-4 items-stretch">
              <PackCard
                featured
                image="/img/single.png"
                imageAlt="Portada del single Ni con el viento a favor, de DELEST"
                kicker="Preventa"
                title="Single + discografía"
                price="5 €"
                blurb={`${CREDITOS} Preventa de 5 €: el single y toda la discografía digital.`}
                items={[
                  'Single «Ni con el viento a favor»',
                  'Discografía completa digital',
                  ENVIO_DIGITAL,
                ]}
                href={checkoutHref(STRIPE_PREVENTA_5, 'la preventa de 5 € (single + discografía digital)')}
                cta="Colabora en el nuevo single"
              />
              <PackCard
                buyNow
                image="/img/cd.png"
                imageAlt="CD físico de Persistencia, de DELEST"
                kicker="Comprar ya"
                title="Single + CD + discografía"
                price="10 €"
                blurb="CD físico de Persistencia, preventa del single y discografía digital. El CD sale hacia tu casa al pedir."
                items={[
                  'Single «Ni con el viento a favor»',
                  'CD Persistencia, a tu casa',
                  'Discografía completa digital',
                  ENVIO_DIGITAL,
                ]}
                href={checkoutHref(STRIPE_CD_10, 'el pack CD de 10 €')}
                cta="Comprar CD 10 €"
              />
              <PackCard
                buyNow
                image="/img/vinilo.png"
                imageAlt="Vinilo de Persistencia, de DELEST"
                kicker="Comprar ya"
                title="Single + vinilo + discografía"
                price="17 €"
                blurb="Vinilo Persistencia, preventa del single y discografía digital. El vinilo sale hacia tu casa al pedir."
                items={[
                  'Single «Ni con el viento a favor»',
                  'Vinilo Persistencia, a tu casa',
                  'Discografía completa digital',
                  ENVIO_DIGITAL,
                ]}
                href={checkoutHref(STRIPE_VINILO_17, 'el pack vinilo de 17 €')}
                cta="Comprar vinilo 17 €"
              />
            </div>
          </section>

          <section id="empresas" className="py-20 relative scroll-mt-24">
            <div className="text-center mb-12">
              <p className="text-[#e60000] font-heading text-xl md:text-2xl uppercase tracking-[0.2em] mb-3">
                Dossier de patrocinio
              </p>
              <h2 className="font-heading text-6xl md:text-8xl uppercase tracking-tighter mb-4">
                Marcas y <span className="text-[#e60000]">empresas</span>
              </h2>
              <p className="text-gray-300 text-lg md:text-xl max-w-3xl mx-auto leading-relaxed">
                Lo que ligas al lanzamiento es tu marca. Quien te representa es el logo: créditos del videoclip, redes,
                YouTube y cartelería digital. En Nufan y Lagwagon el vinilo de Persistencia va de regalo. {ENVIO_DIGITAL}
              </p>
              <a
                href={DOSSIER_PDF}
                download="DELEST-dossier-patrocinio.pdf"
                className="mt-8 inline-block font-heading text-lg md:text-xl uppercase tracking-wider px-8 py-4 border-2 border-white text-white hover:bg-white hover:text-black transition-colors"
              >
                Descargar dossier PDF
              </a>
            </div>

            <div className="max-w-5xl mx-auto mb-16 grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="bg-[#111] border border-gray-800 p-6 text-center">
                <p className="font-heading text-4xl md:text-5xl text-white">101.500</p>
                <p className="text-xs md:text-sm uppercase tracking-[0.18em] text-gray-400 mt-2">
                  Impresiones orgánicas
                </p>
                <p className="text-[11px] text-gray-600 mt-1 uppercase tracking-widest">2026 hasta agosto</p>
              </div>
              <div className="bg-[#111] border border-[#e60000] p-6 text-center">
                <p className="font-heading text-4xl md:text-5xl text-[#e60000]">36.400</p>
                <p className="text-xs md:text-sm uppercase tracking-[0.18em] text-gray-400 mt-2">
                  Cuentas únicas impactadas
                </p>
                <p className="text-[11px] text-gray-600 mt-1 uppercase tracking-widest">Alcance directo</p>
              </div>
              <div className="bg-[#111] border border-gray-800 p-6 text-center">
                <p className="font-heading text-4xl md:text-5xl text-white">1.400</p>
                <p className="text-xs md:text-sm uppercase tracking-[0.18em] text-gray-400 mt-2">
                  Clics en enlaces salientes
                </p>
                <p className="text-[11px] text-gray-600 mt-1 uppercase tracking-widest">Tráfico derivado</p>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-w-5xl mx-auto px-2 md:px-6 items-stretch">
              <div className="relative p-8 flex flex-col h-full transition-all duration-300 bg-[#111] border-2 border-gray-800 hover:border-white">
                <div className="flex-grow">
                  <p className="text-xs uppercase tracking-[0.2em] text-gray-500 mb-2">Opción de colaboración</p>
                  <h3 className="font-heading text-4xl uppercase leading-none mb-2 tracking-tighter">Pack Nufan</h3>
                  <div className="flex items-baseline gap-2 mb-6">
                    <span className="font-heading text-5xl text-[#e60000]">50 €</span>
                  </div>
                  <p className="text-gray-400 mb-8 font-light leading-snug border-t border-gray-800 pt-4">
                    Tu marca entra en el lanzamiento. El logo es lo que te representa: créditos, redes y YouTube. De
                    regalo, el vinilo de Persistencia. {ENVIO_DIGITAL}
                  </p>
                  <ul className="space-y-4 text-left mb-8">
                    <li className="flex items-start text-sm uppercase tracking-tight text-gray-300">
                      <span className="text-[#e60000] font-marker mr-2 text-xl">X</span>
                      <span>Tu logo en los créditos del videoclip oficial</span>
                    </li>
                    <li className="flex items-start text-sm uppercase tracking-tight text-gray-300">
                      <span className="text-[#e60000] font-marker mr-2 text-xl">X</span>
                      <span>Agradecimiento en redes oficiales</span>
                    </li>
                    <li className="flex items-start text-sm uppercase tracking-tight text-gray-300">
                      <span className="text-[#e60000] font-marker mr-2 text-xl">X</span>
                      <span>Marca en la descripción permanente de YouTube</span>
                    </li>
                    <li className="flex items-start text-sm uppercase tracking-tight text-gray-300">
                      <span className="text-[#e60000] font-marker mr-2 text-xl">X</span>
                      <span>Vinilo Persistencia de regalo</span>
                    </li>
                    <li className="flex items-start text-sm uppercase tracking-tight text-gray-300">
                      <span className="text-[#e60000] font-marker mr-2 text-xl">X</span>
                      <span>{ENVIO_DIGITAL}</span>
                    </li>
                  </ul>
                </div>
                <div className="mt-auto grid grid-cols-1 gap-3">
                  <a
                    href={STRIPE_NUFAN}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full block text-center font-heading text-2xl py-4 uppercase tracking-wider transition-all bg-[#e60000] text-white hover:bg-white hover:text-black"
                  >
                    Quiero este pack
                  </a>
                  <a
                    href={WHATSAPP_HREF}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full block text-center font-heading text-sm py-3 uppercase tracking-wider border border-gray-600 text-gray-300 hover:border-white hover:text-white"
                  >
                    WhatsApp
                  </a>
                </div>
              </div>

              <div className="relative p-8 pt-10 flex flex-col h-full transition-all duration-300 bg-[#111] border-4 border-[#e60000] z-10 shadow-[8px_8px_0px_rgba(230,0,0,0.35)]">
                <div className="absolute -top-3 right-6 bg-[#e60000] text-white font-heading text-xs uppercase tracking-widest px-3 py-1">
                  Destacada
                </div>
                <div className="flex-grow">
                  <p className="text-xs uppercase tracking-[0.2em] text-gray-500 mb-2">Opción de colaboración</p>
                  <h3 className="font-heading text-4xl uppercase leading-none mb-2 tracking-tighter">Pack Lagwagon</h3>
                  <div className="flex items-baseline gap-2 mb-6">
                    <span className="font-heading text-5xl text-[#e60000]">100 €</span>
                  </div>
                  <p className="text-gray-400 mb-8 font-light leading-snug border-t border-gray-800 pt-4">
                    Tu marca, con el logo más visible: cartelería del single, una publicación exclusiva y el concierto
                    de presentación. También el vinilo de Persistencia de regalo. {ENVIO_DIGITAL}
                  </p>
                  <ul className="space-y-4 text-left mb-8">
                    <li className="flex items-start text-sm uppercase tracking-tight text-gray-300">
                      <span className="text-[#e60000] font-marker mr-2 text-xl">X</span>
                      <span>Todo lo del pack Nufan</span>
                    </li>
                    <li className="flex items-start text-sm uppercase tracking-tight text-gray-300">
                      <span className="text-[#e60000] font-marker mr-2 text-xl">X</span>
                      <span>Vinilo Persistencia de regalo</span>
                    </li>
                    <li className="flex items-start text-sm uppercase tracking-tight text-gray-300">
                      <span className="text-[#e60000] font-marker mr-2 text-xl">X</span>
                      <span>Tu logo destacado en la cartelería digital del single</span>
                    </li>
                    <li className="flex items-start text-sm uppercase tracking-tight text-gray-300">
                      <span className="text-[#e60000] font-marker mr-2 text-xl">X</span>
                      <span>Post / story individual presentando tu marca</span>
                    </li>
                    <li className="flex items-start text-sm uppercase tracking-tight text-gray-300">
                      <span className="text-[#e60000] font-marker mr-2 text-xl">X</span>
                      <span>2 invitaciones al concierto de presentación, sea la ciudad que sea</span>
                    </li>
                    <li className="flex items-start text-sm uppercase tracking-tight text-gray-300">
                      <span className="text-[#e60000] font-marker mr-2 text-xl">X</span>
                      <span>{ENVIO_DIGITAL}</span>
                    </li>
                  </ul>
                </div>
                <div className="mt-auto grid grid-cols-1 gap-3">
                  <a
                    href={STRIPE_LAGWAGON}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full block text-center font-heading text-2xl py-4 uppercase tracking-wider transition-all bg-[#e60000] text-white hover:bg-white hover:text-black"
                  >
                    Quiero este pack
                  </a>
                  <a
                    href={WHATSAPP_HREF}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full block text-center font-heading text-sm py-3 uppercase tracking-wider border border-gray-600 text-gray-300 hover:border-white hover:text-white"
                  >
                    WhatsApp
                  </a>
                </div>
              </div>
            </div>
          </section>
        </div>

        <div className="container mx-auto px-4 md:px-8 pt-8 md:pt-12 pb-12 md:pb-20">
          <div className="space-y-16 md:space-y-24">
            <section className="py-0 bg-[#0c0c0c] border-y border-gray-900">
              <div className="max-w-4xl mx-auto text-center space-y-8 py-12 px-4">
                <div>
                  <h2 className="font-heading text-4xl md:text-5xl uppercase tracking-wider">
                    Tu apoyo marca la diferencia
                  </h2>
                  <p className="text-gray-500 text-sm uppercase tracking-[0.25em] mt-2">
                    5 € de preventa · CD y vinilo se compran ya
                  </p>
                </div>
                <div className="space-y-6">
                  <p className="text-gray-300 text-lg md:text-xl leading-relaxed max-w-2xl mx-auto">
                    {CREDITOS} La preventa de 5 € es el single y la discografía digital. El físico sale hacia tu casa.
                    Envío del nuevo single en exclusiva antes de la publicación en plataformas.
                  </p>
                  <p className="text-[#e60000] font-heading text-2xl md:text-3xl uppercase tracking-wider">
                    Gracias por el apoyo y por apostar por la cultura local
                  </p>
                </div>
              </div>
            </section>

            <section id="escuchar" className="py-16 bg-black scroll-mt-24">
              <div className="max-w-5xl mx-auto px-4">
                <div className="text-center mb-10">
                  <h2 className="font-heading text-6xl md:text-8xl uppercase tracking-tighter mb-4">
                    Escúcha<span className="text-[#e60000]">nos</span>
                  </h2>
                  <p className="text-gray-400 max-w-xl mx-auto">
                    Spotify para oír el catálogo. En vídeo, Persistencia, el trabajo anterior.
                  </p>
                </div>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch">
                  <div className="relative group">
                    <div className="absolute -inset-3 bg-[#e60000]/20 border-2 border-[#e60000]/50 rotate-1 pointer-events-none group-hover:rotate-0 transition-transform duration-500" />
                    <div className="relative bg-[#050505] border-2 border-white shadow-[6px_6px_0px_rgba(230,0,0,1)] overflow-hidden">
                      <iframe
                        title="DELEST en Spotify"
                        src={`${SPOTIFY_EMBED}&theme=0`}
                        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                        loading="lazy"
                        className="block w-full h-[352px]"
                      />
                    </div>
                  </div>
                  <div className="relative group">
                    <div className="absolute -inset-3 bg-[#e60000]/20 border-2 border-[#e60000]/50 -rotate-1 pointer-events-none group-hover:rotate-0 transition-transform duration-500" />
                    <div className="relative h-[352px] bg-[#050505] border-2 border-white shadow-[6px_6px_0px_rgba(230,0,0,1)] overflow-hidden">
                      <iframe
                        title="Videoclip Persistencia, de DELEST, en YouTube"
                        src="https://www.youtube.com/embed/fPZUhf19FCY?rel=0&amp;autoplay=0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        loading="lazy"
                        referrerPolicy="strict-origin-when-cross-origin"
                        className="absolute inset-0 w-full h-full"
                      />
                    </div>
                  </div>
                </div>
                <p className="mt-8 text-center">
                  <a
                    href={SPOTIFY_OPEN}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-heading text-sm uppercase tracking-[0.2em] text-gray-400 hover:text-white border-b border-gray-600 hover:border-white"
                  >
                    Abrir en Spotify
                  </a>
                </p>
              </div>
            </section>

            <section id="faq" className="py-16 bg-[#050505] border-t border-gray-900">
              <h2 className="font-heading text-5xl md:text-6xl text-center mb-12 uppercase tracking-wider">
                Preguntas frecuentes
              </h2>
              <div className="max-w-3xl mx-auto space-y-4">
                {FAQ_ITEMS.map(({ q, a }, index) => (
                  <details key={q} className="bg-[#111] border border-gray-800 p-6 group" open={index === 0}>
                    <summary className="font-heading text-2xl md:text-3xl text-white cursor-pointer flex justify-between items-center transition-colors hover:text-punk-red">
                      <span className="uppercase tracking-wide">{q}</span>
                      <span className="text-[#e60000] text-4xl transition-transform duration-300 transform group-open:rotate-45 ml-4">
                        +
                      </span>
                    </summary>
                    <p className="text-gray-400 mt-4 text-lg leading-relaxed pt-4 border-t border-gray-700">{a}</p>
                  </details>
                ))}
              </div>
            </section>
          </div>
        </div>
      </main>

      <footer className="bg-[#050505] py-10 text-center text-gray-400 border-t border-gray-900">
        <div className="container mx-auto px-4">
          <p className="font-heading text-2xl md:text-3xl text-white uppercase tracking-wider mb-6">
            Ni con el viento a favor <span className="text-[#e60000]">2026</span>
          </p>
          <div id="contacto" className="mb-6 space-y-2 scroll-mt-24">
            <p className="text-sm md:text-base text-gray-400 uppercase tracking-[0.18em]">Contacto</p>
            <div className="flex flex-col md:flex-row justify-center gap-2 md:gap-4 text-xs md:text-sm">
              <a href={`mailto:${MAIL_INFO}`} className="text-gray-400 hover:text-white transition-colors">
                {MAIL_INFO}
              </a>
              <span className="hidden md:inline text-gray-600">|</span>
              <a href={`mailto:${MAIL_LUCAS}`} className="text-gray-400 hover:text-white transition-colors">
                {MAIL_LUCAS}
              </a>
              <span className="hidden md:inline text-gray-600">|</span>
              <a
                href={WHATSAPP_HREF}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
              >
                +34 627 65 52 13
              </a>
            </div>
          </div>
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 md:gap-x-6 mb-6 text-sm uppercase tracking-[0.18em]">
            {[
              [WEB_OFICIAL, 'Web oficial'],
              [TIENDA_URL, 'Tienda'],
              [INSTAGRAM_URL, 'Instagram'],
              [FACEBOOK_URL, 'Facebook'],
              [YOUTUBE_URL, 'YouTube'],
              [SPOTIFY_OPEN, 'Spotify'],
            ].map(([href, label]) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
              >
                {label}
              </a>
            ))}
          </div>
          <p className="text-sm text-gray-500 max-w-xl mx-auto leading-relaxed">
            Preventa de «Ni con el viento a favor» (5 €: single y discografía digital). {CREDITOS} {ENVIO_DIGITAL} Delest
            Punk Rock © 2026.
          </p>
        </div>
      </footer>
    </div>
  );
}

export default App;
